module.exports = __webpack_public_path__ + "645d664914369111007cbe3f4ed61d28.pdf";